// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "1b3eda28",
    "hash": "1b3eda28",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "1b3eda28",
    "semverString": null,
    "version": "2026.6.0.2"
};
/* tslint:enable */
